import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '380px',
    boxShadow: 'none',
    position: 'relative',
    cursor: 'pointer',
    width: '239px'
  },
  cardMedia: {
    minHeight: '328px',
    maxHeight: '328px'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: `${theme.spacing(5)}px ${theme.spacing(2)}px 0 ${theme.spacing(2)}px !important`
  },
  tagLabels: {
    height: '40px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#8688A1'
  },
  cardName: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    position: 'absolute',
    top: '30%'
  },
  name: {
    color: '#8688A1'
  },
  bookmarkIcon: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1.5),
    cursor: 'pointer'
  },
  cardTypeIcon: {
    position: 'absolute',
    left: theme.spacing(1.5),
    top: theme.spacing(1.5)
  },
  cardUnshareIcon: {
    position: 'absolute',
    height: '25px',
    zIndex: 20,
    right: theme.spacing(2),
    bottom: theme.spacing(11.5)
  },
  tagIcons: {
    display: 'flex',
    position: 'absolute',
    justifyContent: 'center',
    width: '100%',
    bottom: theme.spacing(7.5)
  },
  tagIconsCloud: {
    display: 'flex',
    height: '40px',
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    border: '1px solid #E4E8F1',
    borderRadius: '19px',
    boxShadow: '0 2px 6px 0 rgba(0,0,0,0.08)'
  },
  moreTags: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#8688A1',
    fontWeight: 'normal',
    width: '36px',
    height: '36px',
    fontSize: '12px'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalWrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '85%',
    height: '80%',
    '&:focus': {
      outline: 'none'
    }
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(5, 8),
    width: '100%'
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  closeModalButton: {
    boxSizing: 'border-box',
    height: '50px',
    padding: theme.spacing(2.5, 5),
    borderRadius: '3px',
    marginLeft: 'auto'
  },
  cardDetailsButton: {
    boxSizing: 'border-box',
    height: '36px',
    minWidth: 0,
    width: '36px',
    borderRadius: '50%',
    padding: 0
  },
  cardDetailsCloseButton: {
    boxSizing: 'border-box',
    height: '36px',
    minWidth: 0,
    width: '36px',
    borderRadius: '50%',
    padding: 0,
    marginBottom: theme.spacing(8)
  },
  contentHeader: {
    fontSize: '40px',
    marginBottom: theme.spacing(3),
    maxWidth: '50%'
  },
  textCardContent: {
    maxWidth: '50%',
    fontFamily: 'Tiempos Text',
    fontWeight: 400
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  cardMediaContent: {
    width: '450px',
    height: '65vh',
    backgroundColor: 'transparent',
    '&:focus': {
      outline: 'none'
    }
  },
  cardDetails: {
    width: '30%',
    padding: theme.spacing(5, 8),
    overflowY: 'auto'
  },
  cardDetailsInformationBlock: {
    marginBottom: theme.spacing(5)
  },
  delailsLabel: {
    color: '#8688A1',
    marginBottom: theme.spacing(1)
  },
  delailsLabelAudio: {
    color: '#C4C4D1',
    marginBottom: theme.spacing(1)
  },
  detailsValue: {
    color: '#FFF',
    fontWeight: 'normal'
  },
  detailsValueText: {
    color: '#000',
    fontWeight: 'normal'
  },
  cardDetailsTagValue: {
    display: 'flex',
    alignItems: 'center',
    '& > svg ': {
      marginLeft: theme.spacing(-0.5),
      marginRight: theme.spacing(1)
    }
  }
}))
